import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/marginly-app/src/components/all-trades/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/marginly-app/src/components/common/space.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalWrapper","Wrapper"] */ "/app/packages/marginly-app/src/components/common/wrapper.styled.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Background"] */ "/app/packages/marginly-app/src/components/trade/trade.styled.ts");
